import type { NativePlatform } from "./bridge";

export const OPENING_MOTION_MS = 4_000;
const MAX_GAMMA = 45;
const MAX_SLOPE = 0.04;
/** Sensor ownership ends with the opening animation, hiding, or a motion preference change. */
export function startTilt(platform: NativePlatform, setTilt: (slope: number) => void,
  target: Window = window, batterySaver = false, openedAt = Date.now()): () => void {
  const remaining = OPENING_MOTION_MS - (Date.now() - openedAt);
  const motion = target.matchMedia("(prefers-reduced-motion: reduce)");
  if (platform !== "android" || motion.matches || batterySaver || target.document.hidden || remaining <= 0) return () => undefined;
  const onOrientation = (event: DeviceOrientationEvent): void => {
    if (event.gamma !== null && Number.isFinite(event.gamma)) {
      setTilt(Math.max(-MAX_GAMMA, Math.min(MAX_GAMMA, event.gamma)) / MAX_GAMMA * MAX_SLOPE);
    }
  };
  const stop = (): void => {
    clearTimeout(timer);
    target.removeEventListener("deviceorientation", onOrientation);
    target.document.removeEventListener("visibilitychange", onVisibility);
    motion.removeEventListener("change", onMotionChange);
  };
  const onMotionChange = (): void => { if (motion.matches) { setTilt(0); stop(); } };
  const onVisibility = (): void => { if (target.document.hidden) stop(); };
  const timer = setTimeout(stop, remaining);
  target.addEventListener("deviceorientation", onOrientation);
  target.document.addEventListener("visibilitychange", onVisibility);
  motion.addEventListener("change", onMotionChange);
  return stop;
}
